import React, { useEffect } from 'react';
import '../ServicesStyles/ServicesImageSection.css';

const highlights = [
  { icon: 'bi-cloud-arrow-up', label: 'Cloud Computing' },
  { icon: 'bi-shield-lock', label: 'Cybersecurity' },
  { icon: 'bi-bar-chart-line', label: 'Data Analytics' },
  { icon: 'bi-code-square', label: 'Software Dev' },
];

const ITServiceSection = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="it-services-section">
      <div className="it-services-visual" data-animate="slideInLeft">
        <div className="it-visual-card">
          <div className="it-visual-icon-ring">
            <i className="bi bi-cpu"></i>
          </div>
          <h3 className="it-visual-title">IT Solutions Hub</h3>
          <div className="it-highlights-grid">
            {highlights.map((h, i) => (
              <div className="it-highlight-item" key={i}>
                <i className={`bi ${h.icon}`}></i>
                <span>{h.label}</span>
              </div>
            ))}
          </div>
          <div className="it-visual-stats">
            <div className="it-vstat">
              <span className="it-vstat-num">98%</span>
              <span className="it-vstat-lbl">Client Satisfaction</span>
            </div>
            <div className="it-vstat-sep"></div>
            <div className="it-vstat">
              <span className="it-vstat-num">24/7</span>
              <span className="it-vstat-lbl">Support Available</span>
            </div>
          </div>
        </div>
      </div>

      <div className="it-services-content" data-animate="slideInRight">
        <h2 className="it-services-title">
          Transforming Businesses with<br />
          <span className="it-title-highlight">Innovative IT Solutions</span>
        </h2>
        <p className="it-services-text">
          We provide a comprehensive range of IT services tailored to meet the unique needs of your
          organization. From cloud computing and cybersecurity to data analytics and software
          development, our expert team delivers cutting-edge solutions that drive growth and efficiency.
        </p>
        <blockquote className="it-services-quote">
          "In today's digital age, IT is no longer just a support function; it is the foundation
          for innovation and success."
        </blockquote>
      </div>
    </section>
  );
};

export default ITServiceSection;
